import { Outlet } from "react-router";

export const PrintLayout = () => (
  <div className="min-h-screen bg-background">
    <Outlet />
  </div>
);
